<template>
    <div class="glass pa-3">
        <v-toolbar flat class="rounded-lg">
            <v-toolbar-title>
                Dashboard
            </v-toolbar-title>
            <v-spacer/>
            <v-icon size="x-large" color="primary">
                mdi-chart-areaspline
            </v-icon>
        </v-toolbar>

        <v-card  flat class="rounded-lg mt-5">
            <v-card-text class="pt-1">
                <v-row>
                    <v-col cols="12" sm="4" >
                        <div class="glass rounded-lg pa-2">
                            <div class="d-flex glass-2 rounded-lg ">
                                <div class="ma-1">
                                    <v-avatar class="rounded-lg" size="50" tile color="success">
                                        <v-icon color="white">
                                            mdi-cart-arrow-down
                                        </v-icon>
                                    </v-avatar>
                                </div>
                                <div class="card-details pa-2">
                                    <h3> {{ $page.props.products }} </h3>
                                    <h2 class="mb-1"> Products </h2>
                                </div>
                            </div>
                            <inertia-link as="v-btn" :href="route('admin.products.index')" small block depressed >
                                View More
                            </inertia-link>
                        </div>
                    </v-col>
                    <v-col cols="12" sm="4" >
                        <div class="glass rounded-lg pa-2">
                            <div class="d-flex glass-2  ">
                                <div class="ma-1">
                                    <v-avatar class="rounded-lg" size="50" tile color="error">
                                        <v-icon color="white">
                                            mdi-laptop-account
                                        </v-icon>
                                    </v-avatar>
                                </div>
                                <div class="card-details pa-2">
                                    <h3> {{ $page.props.services }} </h3>
                                    <h2 class="mb-1">Services </h2>
                                </div>
                            </div>
                            <inertia-link as="v-btn" :href="route('admin.services.index')" small block depressed>
                                View More
                            </inertia-link>
                        </div>
                    </v-col>
                    <v-col cols="12" sm="4" >
                        <div class="glass rounded-lg pa-2">
                            <div class="d-flex glass-2 rounded-lg">
                                <div class="ma-1">
                                    <v-avatar class="rounded-lg" size="50" tile color="primary">
                                        <v-icon color="white">
                                            mdi-account-group
                                        </v-icon>
                                    </v-avatar>
                                </div>
                                <div class="card-details pa-2">
                                    <h3> {{ $page.props.team }} </h3>
                                    <h2 class="mb-1"> Team Members </h2>
                                </div>
                            </div>
                            <inertia-link as="v-btn" :href="route('admin.teams.index')" small block depressed>
                                View More
                            </inertia-link>
                        </div>
                    </v-col>
                </v-row>
            </v-card-text>

            <v-card-text>
                <v-row>
                    <v-col cols="12" sm="6">
                         <v-card outlined class="glass">
                             <v-card-title>
                                Latest Products
                                 <v-spacer/>
                                 <inertia-link
                                     :href="route('admin.products.index')"
                                     as="v-btn"
                                     small
                                     depressed
                                 >
                                    View All
                                 </inertia-link>
                             </v-card-title>
                             <v-card-text>
                                 <v-simple-table>
                                     <template v-slot:default>
                                         <thead>
                                         <tr>
                                             <th class="text-left">
                                                 Product Image
                                             </th>
                                             <th class="text-left">
                                                 Product Name
                                             </th>
                                         </tr>
                                         </thead>
                                         <tbody>
                                         <tr
                                             v-for="product in $page.props.products_array"
                                             :key="product.id"
                                         >
                                             <td>
                                                 <img
                                                     :src="product.preview_image"
                                                     height="45px"
                                                     class="ma-1 rounded-lg"
                                                     alt=""
                                                 />
                                             </td>
                                             <td>{{ product.name }}</td>
                                         </tr>
                                         </tbody>
                                     </template>
                                 </v-simple-table>
                             </v-card-text>
                         </v-card>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-card outlined class="glass">
                            <v-card-title>
                                Why Us
                            </v-card-title>
                            <v-card-text>
                                <v-simple-table>
                                    <template v-slot:default>
                                        <thead>
                                        <tr>
                                            <th class="text-left">
                                                Title
                                            </th>
                                            <th class="text-left">
                                                More
                                            </th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr
                                            v-for="why in $page.props.whyus"
                                            :key="why.id"
                                        >
                                            <td>{{ why.title }}</td>
                                            <td>
                                                <inertia-link
                                                    :href="route('admin.why-us.index')"
                                                    as="v-btn"
                                                    small
                                                    depressed
                                                >
                                                    <v-icon size="20" color="primary">
                                                        mdi-pencil-box-multiple-outline
                                                    </v-icon>
                                                </inertia-link>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import AdminLayout from "./AdminLayout";
export default {
    name: "Dashboard",
    layout:AdminLayout
}
</script>

<style scoped>

</style>
